const DISH_TYPE_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  isIgnoredDetailsLoading: false,
  isImageDetailsLoading: false,
  isAdditionalIngredientsDetailsLoading: false,
  isAlternativeIngredientsDetailsLoading: false,
  isNotesLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  ignoredDetailsError: undefined,
  imageDetailsError: undefined,
  additionalIngredientsDetailsError: undefined,
  alternativeIngredientsDetailsError: undefined,
  notesError: undefined,
  data: undefined,
  isAdditionalIngredientsDirty: false,
  isAlternativeIngredientsDirty: false,
  isIgnoredDirty: false,
  isImagesDirty: false,
  isSimpleDetailsDirty: false,
  isNotesDirty: false,
}

export default DISH_TYPE_INITIAL_STATE
